export default "__VITE_ASSET__C36lOeV6__"